/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLookupSet = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M2 2h11v4h9v16H11v-4H2zm9 14V4H4v12zm2 4h7V8h-7zM7.088 5.019l2.939 2.997-2.94 2.997-1.427-1.4 1.566-1.597L5.66 6.419zM19 12h-5v-2h5zm-9 2H5v-2h5zm6.911-.996 1.43 1.398-1.569 1.606 1.57 1.606-1.431 1.397-2.935-3.003z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgLookupSet as LookupSet };
